<template>
    <div>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <b>
                        Print Receipt
                    </b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="learner_receipt_data != null" class="ma-2 no-display" id="wv_btn" tile outlined color="warning"
                @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <v-row id="document1">
                <v-col cols="12" sm="6" md="6" class="m-0 p-0"> </v-col>
                <v-col cols="12" sm="6" md="6" class="m-0 p-0 margin-space">
                    <v-card>
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr v-bind="org_basic_data != ''">
                                        <td colspan="3" v-if="org_basic_data.trust_logo">
                                            <v-row dense justify="center">
                                                <v-col cols="12" md="2" sm="2">
                                                    <center><img :src="org_basic_data.trust_logo" width="150%"
                                                            alt="logo" /></center>
                                                </v-col>
                                                <v-col cols="12" md="10" sm="10" class="line-height">
                                                    <center>
                                                        <span v-if="org_basic_data.trust_name"><b>{{
                                                                org_basic_data.trust_name }}</b></span><br>
                                                        <span v-if="org_basic_data.school_name"><b>{{
                                                                org_basic_data.school_name }} </b></span><br>
                                                        <span v-if="org_basic_data.address">{{ org_basic_data.address
                                                            }}</span><br>
                                                        <span v-if="org_basic_data.phone"> Phone : {{
                                                            org_basic_data.phone }}</span><br>
                                                        <span v-if="org_basic_data.email">Email : {{
                                                            org_basic_data.email }}</span><br>
                                                        <span v-if="org_basic_data.website"></span>Website : {{
                                                        org_basic_data.website }}
                                                    </center>
                                                </v-col>
                                            </v-row>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left line-height" colspan="3">

                                            <span class="text-left"><b> Receipt No. :
                                                    {{ learner_receipt_data.receipt_no }} </b></span>

                                            <span class="text-right"> <b> Receipt Date :
                                                    {{ learner_receipt_data.receipt_date }} </b> </span><br>

                                            <b> Reg No. : {{ learner_receipt_data.registration_number }} </b><br>

                                            <b> Student Name : {{ learner_receipt_data.name }} </b><br>

                                            <b> Class - Section : {{ learner_receipt_data.standard }}
                                                {{ learner_receipt_data.division }}</b><br>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1"><b>Fee Type</b></td>
                                        <td><b> Fee Amount (Rs.)</b></td>
                                        <td><b> Refundable</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td colspan="1">
                                            {{ item.component }}
                                        </td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.is_nonrefundable }}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="3" class="line-height">
                                        <div v-if="learner_receipt_data.fine > 0" class="text-left"><b> Late Fee Charge
                                                :</b>
                                            Rs. {{ learner_receipt_data.fine }}</div>

                                        <div class="text-left"><b> Total Receipt Amount :</b>
                                            Rs. {{ learner_receipt_data.total_fees_amount }}.00</div>

                                        <div class="text-left"><b> Amount In Words :</b>
                                            {{ learner_receipt_data.amount_in_words }}</div>

                                        <div class="text-left"><b> Payment Mode : </b>
                                            {{ learner_receipt_data.payment_mode }}</div>

                                        <div class="text-left" v-if="learner_receipt_data.payment_mode != 'Online'"><b>
                                                Payment Details:</b>
                                            {{ learner_receipt_data.remark }}</div>

                                        <div class="text-left" v-if="learner_receipt_data.payment_mode != 'Cash'"><b> DD /
                                                Cheque / Transaction No.:</b>
                                            {{ learner_receipt_data.trnx_id }}</div>

                                        <div class="text-left" v-if="learner_receipt_data.payment_mode != 'Cash'"><b> DD /
                                                Cheque / Transaction Date:</b>
                                            {{ learner_receipt_data.transaction_date }}</div>

                                        <div class="text-left" v-if="learner_receipt_data.payment_mode != 'Cash'"><b> Bank
                                                Name:</b>
                                            {{ learner_receipt_data.bank_name }}</div>

                                        <div class="text-left" v-if="learner_receipt_data.payment_mode != 'Cash'"><b>
                                                Branch Name :</b>
                                            {{ learner_receipt_data.branch_name }}</div>

                                        <v-row>
                                            <v-col cols="12" sm="5" md="5"> </v-col>
                                            <v-col cols="12" sm="7" md="7">
                                                <span style="position: absolute; right: 50px;"><b>{{ org_basic_data.school_name }}
                                                    </b></span>
                                            </v-col>
                                        </v-row>

                                        <br />
                                        <br />
                                        <span
                                            style="position: absolute; bottom: 40px; right: 120px;"><b>Signature</b></span>

                                        <div class="text-left">* Fees once paid is not refundable/ non-transferable.
                                        </div>
                                        <div class="text-left">* Cheques/ECS/ Online payment are subject to realization.
                                        </div>
                                        <div class="text-left">* Bouncing of Cheques/ ECS will fetch penalty.</div>

                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            overlay: false,
            learner_receipt_data: null,
            radios: null,
            receipt_no: null,
            registration_no: null,
            ay: null,
            org_basic_data: [],
        };
    },
    watch: {
        receipt_no() {
            this.getData();
        },

        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    created() {
        this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
        this.ay = JSON.parse(this.$session.get("ay"));
        this.registration_no = JSON.parse(this.$session.get("registration_no"));
    },
    mounted() {
        this.getData();
    },
    methods: {
        print() {
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
        convert(number) {
            var converter = require("number-to-words");
            const string = converter.toWords(number);
            const string1 = string.charAt(0).toUpperCase() + string.slice(1);
            return string1;
        },
        getData() {
            this.overlay = true;
            this.learner_receipt_data = null;
            const formData = {
                receipt_no: this.receipt_no,
                registration_no: this.registration_no,
                ay: this.ay,
            };
            axios
                .post("/AccountingAndFeesReports/getFeeReceipts", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.learner_receipt_data = res.data.student_receipt_details;
                        this.org_basic_data = res.data.org_basic_data;
                        this.overlay = false;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.overlay = false;
                        return;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.overlay = false;
                })
                .finally(() => {
                    //close loader
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
@media all and (max-width: 900px) {
    .padding-bot {
        padding: 8px;
    }
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    img {
        width: 180% !important;
    }

    body,
    tr,
    th,
    td {
        font-size: xx-large !important;
        /* font-weight: bold !important; */
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        size: 25in 20in;
    }

    table,
    td,
    tr,
    th {
        text-align: center !important;
        margin-top: none;
        padding: 1rem !important;
        font-size: xx-large !important;
        /* font-weight: bold !important; */
        border-bottom: 1px solid black;
        border: 1px solid black;
    }

    .margin-space {
        margin-left: 1160px !important;
    }

    .text-left {
        text-align: left !important;
    }

    .text-right {
        margin-left: 250px !important;
    }

    .line-height {
        line-height: 150% !important;
    }
}

.text-right {
    margin-left: 250px !important;
}

.table-container {
    overflow-x: hidden;
    overflow: hidden;
}
</style>
